import {
  CLAIM_TARIFF_STATUS,
  claimTariffStatusSchema,
  type ClaimTariffStatusValue,
} from './tariff';

export type ProviderClaimStatusValue = Exclude<
  ClaimTariffStatusValue,
  | typeof CLAIM_TARIFF_STATUS.HISTORICAL
  | typeof CLAIM_TARIFF_STATUS.CANCELLED
  | typeof CLAIM_TARIFF_STATUS.UNMATCHED
>;

export const providerClaimStatusDefinitions: Record<
  ProviderClaimStatusValue,
  { label: string }
> = {
  [CLAIM_TARIFF_STATUS.INCOMPLETE]: { label: 'Draft' },
  [CLAIM_TARIFF_STATUS.READY]: { label: 'Ready to submit' },
  [CLAIM_TARIFF_STATUS.REVERTED]: { label: 'Ready to submit' },
  [CLAIM_TARIFF_STATUS.SUBMITTED]: { label: 'Submitted' },
  [CLAIM_TARIFF_STATUS.RESUBMITTED]: { label: 'Resubmitted' },
  [CLAIM_TARIFF_STATUS.PENDING]: { label: 'Pending' },
  [CLAIM_TARIFF_STATUS.QUERIED]: { label: 'Queried' },
  [CLAIM_TARIFF_STATUS.PAYOR_INVOICED]: { label: 'Payor invoiced' },
  [CLAIM_TARIFF_STATUS.REJECTED]: { label: 'Rejected' },
  [CLAIM_TARIFF_STATUS.UNDERPAID]: { label: 'Paid short' },
  [CLAIM_TARIFF_STATUS.UNINSURED]: { label: 'Uninsured' },
  [CLAIM_TARIFF_STATUS.PENDING_WRITE_OFF]: { label: 'Write-Off Pending' },
  [CLAIM_TARIFF_STATUS.UNCLAIMABLE]: { label: 'Unclaimable' },
  [CLAIM_TARIFF_STATUS.PAID]: { label: 'Paid' },
  [CLAIM_TARIFF_STATUS.OVERPAID]: { label: 'Paid' },
  [CLAIM_TARIFF_STATUS.WRITTEN_OFF]: { label: 'Written off' },
};

export const getProviderStatusDisplay = (
  status: string | null | undefined
): string => {
  if (!status) return '';

  const parsedStatus = claimTariffStatusSchema.safeParse(status);
  if (!parsedStatus.success) return status;

  if (
    parsedStatus.data === CLAIM_TARIFF_STATUS.HISTORICAL ||
    parsedStatus.data === CLAIM_TARIFF_STATUS.CANCELLED
  ) {
    return '';
  }
  if (parsedStatus.data === CLAIM_TARIFF_STATUS.UNMATCHED) return status;

  return providerClaimStatusDefinitions[parsedStatus.data].label;
};
